module.exports = __webpack_public_path__ + "img/exchangecard.a6c88c75.png";